const initState = {
  talkingBadge: [],
  votegetterBadges: [],
  singleAmbassodarContent: null,
  singleAmbassodarVideo: null,
  isLoading: false,
  isAddLoading: false,
  lastDocument: null,
  hasMoreDocument: true,
};
const talkingBadgeReducer = (state = initState, action) => {
  switch (action.type) {
    case "TALKING_BADGE_RATING":
      let ratingTalking = state.talkingBadge.map((item) =>
        item.id == action.payload ? { ...item, managerRating: true } : item
      );
      return {
        ...state,
        talkingBadge: ratingTalking,
      };
    case "LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "ADD_LOADING":
      return {
        ...state,
        isAddLoading: action.payload,
      };
    case "GET_TALKING_BADGE":
      return {
        ...state,
        talkingBadge: action.payload.contestData,
        hasMoreDocument: action.payload.hasMoreDocuments,
        lastDocument: action.payload.lastDocument,
      };
    case "GET_VOTEGETTER_BADGE":
      return {
        ...state,
        votegetterBadges: action.payload,
      };
    case "GET_SINGLE_BRAND_AMBASSODAR_CONTEST":
      return {
        ...state,
        singleAmbassodarContent: action.payload,
      };
    case "GET_SINGLE_BRAND_AMBASSADOR_CONTEST_VIDEO":
      return {
        ...state,
        singleAmbassodarVideo: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default talkingBadgeReducer;
